import { Component, HostBinding } from '@angular/core';
import { BaseRenderComponent } from 'cms/workspace/workspace-generic-classes/base-render.component';
import { CMSEvent } from 'render/models/cms-event.model';
import { RenderByDeviceService } from 'render/services/base-render-by-device/render-by-device.service';
import { CMSRenderEventsService } from 'render/services/cms-render-events.service';

import { PieceListItemForClick, PieceListRenderField, PieceListRenderSettings } from './piece-list.models';


@Component({
  selector: 'piece-list-render',
  templateUrl: './piece-list-render.component.html',
  styleUrls: ['./piece-list-render.component.scss']
})
export class PieceListRenderComponent
  extends BaseRenderComponent<PieceListRenderSettings> {

  constructor(
    private readonly cmsRenderEventsService: CMSRenderEventsService,
    private readonly renderByDeviceService: RenderByDeviceService
  ) {
    super();
  }

  @HostBinding('style.--bullet-image')
  public get bulletImage(): string {
    return `url('${this.settings.general?.listStyles.customIcon ?? ''}')`;
  }

  @HostBinding('style.--bullet-width')
  public get bulletWidth(): string | undefined {
    return this.settings.general?.listStyles.customIconWidth;
  }

  @HostBinding('style.--bullet-height')
  public get bulletHeight(): string | undefined {
    return this.settings.general?.listStyles.customIconHeight;
  }

  @HostBinding('style.--number-of-columns')
  public get numberOfColumns(): number {
    let numberOfColumns: number | undefined;
    if (this.renderByDeviceService.isMobile) {
      numberOfColumns = this.settings.general.listStyles.numberOfColumns.numberOfColumnsMobile;
    } else {
      numberOfColumns = this.settings.general.listStyles.numberOfColumns.numberOfColumnsDesktop;
    }
    return numberOfColumns ?? 1;
  }

  @HostBinding('style.--column-spacing')
  public get columnSpacing(): string | undefined {
    return this.settings.general?.listStyles.columnSpacing;
  }

  @HostBinding('style.--row-spacing')
  public get rowSpacing(): string | undefined {
    return this.settings.general?.listStyles.rowSpacing;
  }

  @HostBinding('class')
  public get classes(): string {
    return this.settings.styles.customClassesList ?? '';
  }

  public get listTitle(): string {
    return this.settings.general?.listTitle ?? '';
  }

  public get isOrdered(): boolean {
    return this.settings.general?.listStyles.listType === 'ordered';
  }

  public get listClass(): string {
    const bulletType = this.settings.general?.listStyles.bulletType;
    if (bulletType === undefined) {
      return 'list-style-none';
    }

    if (bulletType === 'customBullet') {
      return 'list-style-custom-bullet';
    }

    if (bulletType === 'dash') {
      return 'list-style-type-dash';
    }

    return `list-style-type-${bulletType}`;
  }

  public get listContent(): PieceListRenderField[] {
    return (this.settings.general.listContent ?? []);
  }

  public trackByIndex(index: number): number {
    return index;
  }

  public itemClicked(item: string): void {
    const cmsEvent: CMSEvent<PieceListItemForClick> = {
      name: 'pieceListLink',
      type: 'click',
      data: { item } as PieceListItemForClick
    };
    this.cmsRenderEventsService.emitEvent(cmsEvent);
  }

}
